import { ContextMenu, ContextMenuItemProps } from '@kontentino/ui';
import { Action, ActionProps, resolveLabel } from 'actions';
import UserPermissionGate from 'components/UserPermissionGate';
import { Fragment } from 'react';

export type ActionContextMenuItemProps<TAction extends Action> =
  ContextMenuItemProps &
    ActionProps<TAction> & {
      separator?: {
        before?: boolean;
        after?: boolean;
      };
    };

export const ActionContextMenuItem = function <TAction extends Action>({
  action,
  actionParams,
  children,
  separator,
  ...props
}: ActionContextMenuItemProps<TAction>) {
  return (
    <UserPermissionGate scopes={action.scopes}>
      <Fragment>
        {separator?.before && <ContextMenu.Separator />}
        <ContextMenu.Item
          onClick={() => action.perform?.(actionParams)}
          {...props}
        >
          {children ?? (
            <Fragment>
              {action.icon}
              {resolveLabel(action.label)}
            </Fragment>
          )}
        </ContextMenu.Item>
        {separator?.after && <ContextMenu.Separator />}
      </Fragment>
    </UserPermissionGate>
  );
};
